"use strict";
var parser = require("./parser")["default"];
var AST = require("./ast");

exports.parser = parser;

function parse(input) {
  // Just return if an already-compile AST was passed in.
  if(input.constructor === AST.ProgramNode) { return input; }

  parser.yy = AST;
  return parser.parse(input);
}

exports.parse = parse;


//////////////////
// WEBPACK FOOTER
// ./~/handlebars/dist/cjs/handlebars/compiler/base.js
// module id = 65
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21